import { Theme } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React from "react";
import PastPeriod from "./PastPeriod";
import Title from "./Title";
import Today from "./Today";
import { ItemFC } from "./types";

const Item: ItemFC = ({ isLoading, type, name, today, month, statistic }) => {
  const isDisplaySmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("md")
  );
  return (
    <Grid item xs={6} sm={6} md={3} lg={3}>
      <Paper sx={{ padding: { xs: 1, md: 2, lg: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Title title={name} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginY: { xs: 1, lg: 2 },
          }}
        >
          <Today
            value={statistic?.today}
            suffix={today?.suffix}
            isLoading={isLoading}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <PastPeriod
            text={"Вчера"}
            value={statistic?.yesterday}
            suffix={month?.suffix}
            dynamic={statistic?.dinamicYesterday}
            isLoading={isLoading}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <PastPeriod
            text={isDisplaySmall ? "Месяц" : "За месяц"}
            value={statistic?.month}
            suffix={month?.suffix}
            dynamic={statistic?.dinamicMonth}
            isLoading={isLoading}
          />
        </Box>
      </Paper>
    </Grid>
  );
};

export default React.memo(Item);
